import * as React from "react"
import { Box, Button } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import {
    canSearch,
    isLoadingFilters,
    selectedSites,
    selectedBrands,
    selectedMarkets,
    selectedBatches,
    searchText,
    tableData,
    totalCount,
    currentPage,
    selectedRows
} from "../@signals"


export default function SkuCandidatesFiltersFooter() {
    const handleSearch = () => {
        currentPage.value = 0
        selectedRows.value = []
        isLoadingFilters.value = true
    }

    const handleClear = () => {
        selectedMarkets.value = []
        selectedSites.value = []
        selectedBrands.value = []
        selectedBatches.value = []
        searchText.value = ''
        tableData.value = []
        totalCount.value = 0
        currentPage.value = 0
        selectedRows.value = []
    }

    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
                variant="outlined"
                size="small"
                onClick={handleClear}
                disabled={isLoadingFilters.value}
            >
                Clear
            </Button>
            <Button
                variant="contained"
                size="small"
                onClick={handleSearch}
                disabled={!canSearch.value || isLoadingFilters.value}
                startIcon={isLoadingFilters.value ? <IconSeeker icon="spinner" spin="true" /> : <IconSeeker icon="search" />}
            >
                Search
            </Button>
        </Box>
    )
}
